/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BcProductCategoryResponsePaging } from '../../models/bc-product-category-response-paging';

export interface GetBusinessCentralProductList$Params {
  page: number;
  pageSize: number;
  orderBy?: string;
  filter?: string;
  productFilter?: string;
}

export function getBusinessCentralProductList(http: HttpClient, rootUrl: string, params: GetBusinessCentralProductList$Params, context?: HttpContext): Observable<StrictHttpResponse<BcProductCategoryResponsePaging>> {
  const rb = new RequestBuilder(rootUrl, getBusinessCentralProductList.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('filter', params.filter, {});
    rb.query('productFilter', params.productFilter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BcProductCategoryResponsePaging>;
    })
  );
}

getBusinessCentralProductList.PATH = '/business-central/products';
